/* global document */
import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField, Popover, RaisedButton, FontIcon, Divider,
} from 'material-ui';
import { PopoverAnimationFromTop } from 'material-ui/Popover';
import { connect } from 'react-redux';
import { propOr, prop } from 'ramda';
import injectSheet from 'react-jss';
import { Link } from 'react-router'
import { connectionResponseTime } from '../../stores/partner-finder/partnerFinder-actions';
import stopSign  from '../../../www/images/stop-sign.png';

const styles = {
  popOver: {
    padding: '1em',
    width: '400px',
  },
  popOver2: {
    padding: '1em',
    width: '500px',
  },
  header: {
    fontSize: '1.3em',
    fontWeight: 'bolder',
    marginBottom: '0.8em',
  },
  paragraph1: {
    marginTop: '0.8em',
    fontSize: '1em',
  },
  inputWrap: {
    overflow: 'auto',
    minHeight: '80px',
    border: '1px solid #00BCD4',
    margin: '0.8em 0 0.8em 0',
    paddingLeft: '0.8em',
  },
  paragraph2: {
    fontSize: '0.8em',
    fontStyle: 'italic',
    marginBottom: '0.8em',
  },
  paragraph_profile1: {
    marginTop: '0.8em',
    fontSize: '1em',
    textAlign: 'center',
    '& p': {
      fontWeight: 'bold',
    },
  },
  paragraph_profile2: {
    fontSize: '0.8em',
    fontStyle: 'italic',
    marginBottom: '0.8em',
    textAlign: 'center',
  },
};
const SendCustomMsg = ({
  companyName,
  getRespTime,
  onRequestClose,
  sendCustomMsg,
  sendInvitation,
  classes: css,
  updateCustomizedMsg,
  isMarketingReady,
  marketingReadinessPercentage,
}) => {
  const {
    open, popOverAnchorEl, customizedMessage, receiverInfo,
  } = sendCustomMsg;
  const text = customizedMessage || `${companyName} would like to connect with ${propOr('you', 'companyName', receiverInfo)} on TourConnect.`;
  if (!isMarketingReady || marketingReadinessPercentage < 100) {
    return (
    <Popover
      open={open}
      anchorEl={document.getElementById(popOverAnchorEl)}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      targetOrigin={{ horizontal: 'middle', vertical: 'top' }}
      animation={PopoverAnimationFromTop}
      onRequestClose={onRequestClose}
      className={css.popOver2}
    >
      <div className={css.header}>Marketing Profile</div>
      <div className={css.paragraph_profile1}>
        <div style={{ marginBottom: '1em' }}>
          <img src={stopSign} style={{ width: '150px', height: '150px' }}/>
        </div>
        <p>
          Please complete your Marketing Profile<br />before sending a Partner Request.
        </p>
        <p>
          This helps us maintain the quality of the TourConnect network.
        </p>
      </div>
      <Divider />
      <div className={css.paragraph_profile2}>
        If you need help completing your <Link to="/profile">profile</Link>, <br />please reference our <a href="https://support.tourconnect.com/en/collections/613143-sales-marketing-marketing-profile" target="_blank">help articles and videos</a> or <a href="support@tourconnect.com">contact us</a>.
      </div>
    </Popover>
    );
  }
  return (
    <Popover
      open={open}
      anchorEl={document.getElementById(popOverAnchorEl)}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      targetOrigin={{ horizontal: 'middle', vertical: 'top' }}
      animation={PopoverAnimationFromTop}
      onRequestClose={onRequestClose}
      className={css.popOver}
    >
      <div className={css.header}>Customize your connection request</div>
      <Divider />
      <div className={css.paragraph1}>
        {'Companies are much more likely to accept your connection \
        request if you send a personal note.'}
      </div>
      <div className={css.inputWrap}>
        <FontIcon className="tc-icon-email" color="#bfbfbf" style={{ top: '12px' }} />
        <TextField
          id="commentBoxTextField"
          hintStyle={{ fontSize: '14px' }}
          underlineShow={false}
          value={text}
          onChange={({ target: { value } }) => updateCustomizedMsg({ customizedMessage: value })}
          style={{
            float: 'right', width: '85%', marginRight: '5%', fontSize: '14px', lineHeight: '18px',
          }}
          multiLine
          rowsMax={5}
          maxLength="400"
        />
      </div>
      <div className={css.paragraph2}>
        {"* Remember, these are B2B connections, so responses may take longer \
          than you expect. Don't be afraid to follow up in a week or two."}
      </div>
      <RaisedButton
        secondary
        style={{ float: 'right' }}
        label="send"
        onTouchTap={() => {
          getRespTime(prop('companyId', receiverInfo));
          sendInvitation(customizedMessage, receiverInfo);
        }}
      />
    </Popover>
  );
};

SendCustomMsg.propTypes = {
  classes: PropTypes.object.isRequired,
  companyName: PropTypes.string.isRequired,
  getRespTime: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  sendCustomMsg: PropTypes.object.isRequired,
  sendInvitation: PropTypes.func.isRequired,
  updateCustomizedMsg: PropTypes.func.isRequired,
};

const mapStateToProps = ({ partnerFinder, user, profile }) => ({
  isMarketingReady: profile.get('isMarketingReady'),
  marketingReadinessPercentage: profile.get('marketingReadinessPercentage'),
  sendCustomMsg: partnerFinder.get('sendCustomMsg').toJS(),
  userName: user.getIn(['user', 'name']),
  companyName: user.getIn(['company', 'companyName']),
});

const mapDispatchToProps = dispatch => ({
  getRespTime: companyId => dispatch(connectionResponseTime(companyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(SendCustomMsg));



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/send-custom-msg.jsx